/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
// import { setCurrentUser } from "../store/actions/authActions.js";
import { Button, Modal } from "flowbite-react";
import { NavLink, useNavigate } from "react-router-dom";
import instance, { fetchEntryDueDate } from "../../api/api";
import { Loader } from "../../components/Loader";

function EmployeeKickoffPhase() {
    const [entryDueDate, setEntryDueDate] = useState(new Date());
    const [isLaunched, setIsLaunched] = useState(false);
    const today = new Date();

    useEffect(() => {
        const fetchDueDate = async () => {
          const theDueDate = await fetchEntryDueDate();

          if (theDueDate !== null) {
            setIsLaunched(true);
          } else {
            setIsLaunched(false);
          }

          setEntryDueDate(theDueDate);
        }
    
        fetchDueDate();
      }, [])

  return (
    <>
      {/* <!-- Breadcrumb --> */}
      <nav
        className="justify-between  py-3 text-gray-700  sm:flex bg-gray-50"
        aria-label="Breadcrumb"
      >
        <ol className="inline-flex items-center mb-3 space-x-1 md:space-x-2 rtl:space-x-reverse sm:mb-0">
          <li>
            <div className="flex items-center">
              <NavLink
                to=""
                className=" text-sm font-medium text-gray-700 hover:text-blue-600  dark:text-gray-400 dark:hover:text-white"
              >
                Risk Registration
              </NavLink>
            </div>
          </li>

          <li aria-current="page">
            <div className="flex items-center ">
              <svg
                className="rtl:rotate-180 w-3 h-3 mx-1 text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 6 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 9 4-4-4-4"
                />
              </svg>
              <span className="mx-1 text-sm font-medium text-gray-500 md:mx-2 dark:text-gray-400">
                Kickoff
              </span>
            </div>
          </li>
        </ol>
      </nav>

      <div className="border-2 border-dashed p-6 rounded-lg border-red-300 dark:border-gray-600 h-54 mb-4">
        <div className="space-y-6">
          <h3 className="text-riskRed font-medium text-lg">{isLaunched ? "Launched!" : "Waiting to launch"} </h3>
          <div className="flex items-center space-x-5">
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    // user: state.userData.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // setUser: (user) => dispatch(setCurrentUser(user)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeKickoffPhase);
